import React, { useState, useEffect } from 'react';
import { FRONTEND_VERSION } from '../config/version';
import './VersionUpdateBadge.css';

const VersionUpdateBadge = ({ isRunning, dismissedByResumeDialog = false }) => {
  const STORAGE_KEY_LAST_VERSION = 'stoppuhr_last_seen_version';
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Prüfe, ob eine neue Version verfügbar ist
    const lastSeenVersion = localStorage.getItem(STORAGE_KEY_LAST_VERSION);
    
    // Prüfe, ob der Benutzer die Badge bereits für diese Version geschlossen hat
    const dismissedVersion = localStorage.getItem('stoppuhr_version_badge_dismissed');
    if (dismissedVersion === FRONTEND_VERSION) {
      setIsDismissed(true);
      setIsVisible(false);
      return;
    }
    
    // Wenn eine vorherige Version existiert UND sich die Version geändert hat
    // (nicht beim ersten Start)
    if (lastSeenVersion && lastSeenVersion !== FRONTEND_VERSION) {
      setIsVisible(true);
    }
    
    // Speichere die aktuelle Version (auch beim ersten Start)
    localStorage.setItem(STORAGE_KEY_LAST_VERSION, FRONTEND_VERSION);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setIsDismissed(true);
    // Speichere, dass diese Version bereits geschlossen wurde
    localStorage.setItem('stoppuhr_version_badge_dismissed', FRONTEND_VERSION);
  };

  if (dismissedByResumeDialog || !isVisible || isDismissed) return null;

  return (
    <div className="version-update-badge">
      <div className="version-update-content">
        <div className="version-update-header">
          <span className="version-update-icon">🆕</span>
          <span className="version-update-title">Neue Version verfügbar</span>
          <button className="version-update-close" onClick={handleClose}>×</button>
        </div>
        <div className="version-update-body">
          <p className="version-update-version">
            Version <strong>{FRONTEND_VERSION}</strong> wurde installiert.
          </p>
          {isRunning && (
            <div className="version-update-safety-hint">
              <span className="version-update-safety-icon">✅</span>
              <span className="version-update-safety-text">
                Ihre laufende Messung wird automatisch gesichert. Kein Datenverlust während der Messung.
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VersionUpdateBadge;
